import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { CircularProgress } from '@mui/material';
import { useFileContext } from '../../../Context/FileContext';
import ProductDetails from '../Add/AddItemComps/ProductDetails';
import ServiceDetails from '../Add/AddItemComps/ServiceDetails';
import CourseDetails from '../Add/AddItemComps/CourseDetails';
import OtherDetails from '../Add/AddItemComps/OtherDetails';
import { fetchOptions, updateCourse, updateProduct, updateService } from '../../../API/functions';
import AppointmentDetails from './AppointmentDetails';

const Edit = () => {
    const [type, setType] = useState('');
    const [formData, setFormData] = useState({});
    const [data, setData] = useState([]);
    const { files, setShowModal } = useFileContext();
    const [loading, setLoading] = useState(false);
    const [selectedOptionId, setSelectedOptionId] = useState('');
    const links = {
        product: "products",
        service: "services",
        course: "courses",
        dayOff: "appointments/days-off",
        appointments: "appointments",
    };

    useEffect(() => {
        // Fetch existing data based on type
        const fetchData = async () => {
            try {
                const fetchedData = await fetchOptions(links[type]);
                if (type === 'appointments') {
                    const sortedAppointments = fetchedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                    setData(sortedAppointments);
                } else {
                    setData(fetchedData);
                }
            } catch (error) {
                setData([])
                console.error('Error fetching data:', error);
            }
        };

        if (type) {
            fetchData();
        }
    }, [type]);

    const handleTypeChange = (e) => {
        setType(e.target.value);
        setFormData({});
        setSelectedOptionId('');
    };

    const handleSecondSelectChange = (e) => setSelectedOptionId(e.target.value);

    const updateFiles = () => {
        if (formData && type && formData[type]) {
            formData[type].files = files || [];
        }
    };

    useEffect(() => {
        updateFiles();
    }, [files]);

    const handleFormDataChange = (data) => {
        setFormData(prevData => ({ ...prevData, [type]: data }));
    };
    const getSelectedItem = () => {
        return data.find(item => item._id === selectedOptionId) || null;
    };
    const isFormComplete = () => {
        switch (type) {
            case 'product':
                return formData.product &&
                    formData.product.name &&
                    formData.product.price &&
                    formData.product.quantity &&
                    formData.product.description;
            case 'service':
                return formData.service &&
                    formData.service.name &&
                    formData.service.description &&
                    formData.service.price &&
                    formData.service.duration;
            case 'course':
                return formData.course &&
                    formData.course.title &&
                    formData.course.description &&
                    formData.course.price &&
                    formData.course.duration;
            case 'other':
                return formData.other &&
                    formData.other.name;
            default:
                return false;
        }
    };

    const UpdateButton = () => (
        <div>
            {!loading ?
                <button onClick={handleUpdateClick} disabled={!isFormComplete()}>
                    Update
                </button>
                : <CircularProgress />
            }
        </div>
    );

    const handleUpdateClick = async () => {
        setLoading(true);
        try {
            updateFiles();

            if (type === 'product') {
                await updateProduct(formData.product);
                toast.success('Product updated successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            } else if (type === 'course') {
                await updateCourse(formData.course);
                toast.success('Course updated successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            } else if (type === 'service') {
                await updateService(formData.service);
                toast.success('Service updated successfully', {
                    position: "bottom-right",
                    draggable: true,
                });
            }
            setShowModal(false);
        } catch (error) {
            toast.error(`Failed to update item: ${error.message}`, {
                position: "bottom-right",
                draggable: true,
            });
        }
        setLoading(false);
    };

    return (
        <div>
            <h2>Edit Item</h2>
            <select onChange={handleTypeChange} value={type}>
                <option value="">Select Type</option>
                <option value="product">Product</option>
                <option value="service">Service</option>
                <option value="course">Course</option>
                <option value="dayOff">Day off</option>
                <option value="appointments">Appointment</option>
                <option value="other">Other</option>
            </select>
            {type && type !== "other" && type !== "appointments" && (
                <select value={selectedOptionId} onChange={handleSecondSelectChange}>
                    <option value="">Select {type}</option>
                    {data.map(option => (
                        <option key={option._id} value={option._id}>
                            {option.name}
                        </option>
                    ))}
                </select>
            )}
            {type && type === "appointments" && (
                <select value={selectedOptionId} onChange={handleSecondSelectChange}>
                    <option value="">Select Appointment</option>
                    {data.map(option => (
                        <option key={option._id} value={option._id}>
                            {`${option.customerName} - ${new Date(option.appointmentDate).toLocaleDateString()} - ${option.serviceId.name}`}
                        </option>
                    ))}
                </select>
            )}
            {type === 'product' && selectedOptionId && <ProductDetails initialValues={getSelectedItem()} onDataChange={handleFormDataChange} />}
            {type === 'service' && selectedOptionId && <ServiceDetails initialValues={getSelectedItem()} onDataChange={handleFormDataChange} />}
            {type === 'course' && selectedOptionId && <CourseDetails initialValues={getSelectedItem()} onDataChange={handleFormDataChange} />}
            {type === 'other' && selectedOptionId && <OtherDetails initialValues={getSelectedItem()} onDataChange={handleFormDataChange} />}
            {type === 'appointments' && selectedOptionId && <AppointmentDetails initialValues={getSelectedItem()} onDataChange={handleFormDataChange} />}
            {type && !selectedOptionId && <p>No data available!</p>}
            <div style={{ height: "1px", width: "90%", backgroundColor: "black", margin: "10px 5% 10px" }} />
            {type && <UpdateButton />}
            <ToastContainer />
        </div>
    );
};

export default Edit;
